/* SkyClean Drones – Ortsseiten „Bühne“: Bewegung.

     1 · Einpassen    – Ortsname füllt genau die Breite
     2 · Einblenden   – [data-o2-fade] fährt einmal herein
     3 · Magnet       – die Drohne folgt dem Zeiger, wenn er nahe kommt
     4 · Bänder       – zwei Bildreihen laufen beim Scrollen gegeneinander
     5 · Lichtschrift – der Ortstext wird Zeichen für Zeichen hell
     6 · Stapel       – Karten werden kleiner, wenn die nächste darüber kommt

   Grundsatz: Ohne Skript ist alles sichtbar. Bei „Bewegung reduzieren“
   wird nur eingepasst, sonst bewegt sich nichts. */
(function () {
  'use strict';
  /* Jede Section bindet das Skript ein – es läuft trotzdem nur einmal */
  if (window.__o2) return;
  window.__o2 = true;

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasIO = 'IntersectionObserver' in window;
  if (hasIO && !reduce) root.classList.add('o2-js');

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* Höhe der Kopfleiste, damit die Bühne genau einen Bildschirm füllt */
  function headHeight() {
    var h = document.querySelector('.shopify-section-header, header.header, .scx-header, #shopify-section-header');
    root.style.setProperty('--o2-head', (h ? Math.round(h.getBoundingClientRect().height) : 0) + 'px');
  }

  /* ------------------------------------------------------- 1 · Einpassen */
  function fitAll() {
    document.querySelectorAll('[data-o2-fit]').forEach(function (el) {
      var box = el.parentElement;
      var max = parseFloat(el.getAttribute('data-o2-fit')) || 0.24;
      el.style.fontSize = '100px';
      var w = el.scrollWidth;
      if (!w) return;
      var size = 100 * box.clientWidth / w;
      el.style.fontSize = Math.min(size, window.innerWidth * max) + 'px';
      /* Bühne: Unterkante des Ortsnamens merken, die Drohne greift dort hinein */
      var hero = el.closest('.o2-hero');
      if (hero) {
        /* Layout-Lage statt Bildschirmlage – das Einblenden verschiebt sonst die Messung */
        var top = 0, n = el;
        while (n && n !== hero) { top += n.offsetTop; n = n.offsetParent; }
        hero.style.setProperty('--o2-wordb', Math.round(top + el.offsetHeight) + 'px');
        hero.style.setProperty('--o2-wordh', el.offsetHeight + 'px');
      }
    });
  }

  /* ------------------------------------------------------ 2 · Einblenden */
  function fades(scope) {
    var nodes = scope.querySelectorAll('[data-o2-fade]:not(.is-in)');
    if (!nodes.length) return;
    if (!hasIO || reduce) { nodes.forEach(function (n) { n.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '50px 0px', threshold: 0 });
    nodes.forEach(function (n) { io.observe(n); });
    /* Sicherheitsnetz: lieber ohne Bewegung zu sehen als gar nicht */
    setTimeout(function () {
      scope.querySelectorAll('[data-o2-fade]:not(.is-in)').forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) n.classList.add('is-in');
      });
    }, 2200);
  }

  /* ---------------------------------------------------------- 3 · Magnet */
  function magnet(el) {
    if (reduce || !finePointer || el.dataset.o2m) return;
    el.dataset.o2m = '1';
    var pad = 150, strength = 3, active = false;
    window.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var near = Math.abs(cx - e.clientX) < r.width / 2 + pad && Math.abs(cy - e.clientY) < r.height / 2 + pad;
      if (near) {
        if (!active) { active = true; el.style.transition = 'transform .3s ease-out'; }
        el.style.transform = 'translate3d(' + ((e.clientX - cx) / strength).toFixed(1) + 'px,' + ((e.clientY - cy) / strength).toFixed(1) + 'px,0)';
      } else if (active) {
        active = false;
        el.style.transition = 'transform .6s ease-in-out';
        el.style.transform = 'translate3d(0,0,0)';
      }
    }, { passive: true });
  }

  /* ----------------------------------------------------------- 4 · Bänder */
  var bands = [];
  function band(sec) {
    if (reduce || sec.dataset.o2b) return;
    sec.dataset.o2b = '1';
    var rows = [].slice.call(sec.querySelectorAll('[data-o2-row]'));
    bands.push({ sec: sec, rows: rows.map(function (r) {
      return { el: r, dir: r.getAttribute('data-o2-row') === '-1' ? -1 : 1, set: 0 };
    }) });
    measureBands();
  }
  function measureBands() {
    bands.forEach(function (b) {
      b.rows.forEach(function (r) {
        /* Inhalt liegt dreifach im Band – eine Runde ist ein Drittel */
        r.set = r.el.scrollWidth / 3;
      });
    });
  }
  function updateBands() {
    bands.forEach(function (b) {
      var r = b.sec.getBoundingClientRect();
      if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
      var offset = (window.innerHeight - r.top) * 0.3;
      b.rows.forEach(function (row) {
        if (!row.set) return;
        var m = ((offset % row.set) + row.set) % row.set;
        var x = row.dir === 1 ? m - row.set : -m;
        row.el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      });
    });
  }

  /* ----------------------------------------------------- 5 · Lichtschrift */
  var glows = [];
  function glow(p) {
    if (reduce || p.dataset.o2g) return;
    p.dataset.o2g = '1';
    var text = p.textContent.replace(/\s+/g, ' ').trim();
    p.textContent = '';
    /* Vorlesen: eine ruhige Klartext-Kopie, die Einzelbuchstaben sind stumm */
    var sr = document.createElement('span');
    sr.className = 'o2-sr';
    sr.textContent = text;
    p.appendChild(sr);
    var chars = [];
    text.split(' ').forEach(function (word, wi, all) {
      var w = document.createElement('span');
      w.className = 'o2-w';
      w.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < word.length; i++) {
        var c = document.createElement('span');
        c.className = 'o2-c';
        c.textContent = word[i];
        w.appendChild(c);
        chars.push(c);
      }
      p.appendChild(w);
      if (wi < all.length - 1) p.appendChild(document.createTextNode(' '));
    });
    glows.push({ el: p, chars: chars, last: -1 });
  }
  function updateGlows() {
    var vh = window.innerHeight;
    glows.forEach(function (g) {
      var r = g.el.getBoundingClientRect();
      /* Bereich: Oberkante bei 80 % … Unterkante bei 20 % des Fensters */
      var p = clamp((vh * 0.8 - r.top) / (r.height + vh * 0.6), 0, 1);
      var lit = p * g.chars.length;
      var key = Math.round(lit * 4);
      if (key === g.last) return;
      g.last = key;
      for (var i = 0; i < g.chars.length; i++) {
        g.chars[i].style.opacity = (0.2 + 0.8 * clamp(lit - i, 0, 1)).toFixed(2);
      }
    });
  }

  /* ----------------------------------------------------------- 6 · Stapel */
  var stacks = [];
  function stack(el) {
    if (reduce || el.dataset.o2s) return;
    el.dataset.o2s = '1';
    stacks.push({ el: el, cards: [].slice.call(el.querySelectorAll('.o2-card')) });
  }
  function updateStacks() {
    if (window.innerWidth <= 700) return;
    var vh = window.innerHeight;
    stacks.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      var total = s.el.offsetHeight - vh;
      var prog = total > 0 ? clamp(-r.top / total, 0, 1) : 0;
      var n = s.cards.length;
      s.cards.forEach(function (card, i) {
        var target = 1 - (n - 1 - i) * 0.03;
        var start = i / n;
        var t = clamp((prog - start) / (1 - start || 1), 0, 1);
        card.style.transform = 'scale(' + (1 + (target - 1) * t).toFixed(4) + ')';
      });
    });
  }

  /* ------------------------------------------------------------ Taktgeber */
  var ticking = false;
  function frame() {
    ticking = false;
    updateBands();
    updateGlows();
    updateStacks();
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }

  function init(scope) {
    scope = scope || document;
    headHeight();
    fades(scope);
    scope.querySelectorAll('[data-o2-magnet]').forEach(magnet);
    scope.querySelectorAll('[data-o2-band]').forEach(band);
    scope.querySelectorAll('[data-o2-glow]').forEach(glow);
    scope.querySelectorAll('[data-o2-stack]').forEach(stack);
    fitAll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitAll(); measureBands(); frame(); });
    frame();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { headHeight(); fitAll(); measureBands(); frame(); }, 120);
  });
  window.addEventListener('load', function () { fitAll(); measureBands(); frame(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
